import React from 'react';
import cn from 'classnames';
import LazyImage from 'components/UI/LazyImage';
import Markup from 'components/Markup';
import * as styles from './text.module.scss';

export function Component({ content, className }) {
  const { icon, title, text } = content;
  return (
    <div className={cn(className, styles.wrapper)}>
      {icon && <LazyImage src={icon} alt={title ?? 'Icon'} className={styles.icon} />}
      {title && <p className={styles.title}>{title}</p>}
      <Markup tag="p" className={styles.text}>
        {text}
      </Markup>
    </div>
  );
}
